<template>
  <div>
    <div class="page-wrapper" :class="layoutobj">
      <!--<div class="page-header" :class="{ close_icon: !togglesidebar }">
        <Header @clicked="sidebar_toggle" />
      </div>-->
      <div class="page-body-wrapper" style="margin-top: -130px;">
        <!--<div class="bg-overlay" :class="{ active: activeoverlay }" @click="removeoverlay()"></div>
        <div class="sidebar-wrapper" style="z-index: 11;" :class="[{ close_icon: !togglesidebar }]"
          :sidebar-layout="layout.settings.sidebar_setting">
          <Sidebar @clicked="sidebar_toggle" />
        </div>-->
        <div class="page-body" @click="hidesecondmenu()">
          <transition name="content" mode="out-in" appear>
            <router-view class="view"></router-view>
          </transition>
        </div>
        <Footer />
      </div>
      <!--<Customizer/>-->
      <TapTop />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { layoutClasses } from '../constants/layout';
import Header from './header';
import Sidebar from './sidebar';
import Footer from './footer';
import TapTop from './taptop';
//import Customizer from './customizer';

export default {
  name: 'mainpage',
  // props:['sidebar_toggle_var'],
  components: {
    Header,
    Sidebar,
    //Customizer,
    Footer,
    TapTop,
  },
  data() {
    return {
      mobileheader_toggle_var: false,
      sidebar_toggle_var: false,
      horizontal_Sidebar: true,
      resized: false,
      layoutobj: {},
      WorkerIO: null,
    };
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      layout: (state) => state.layout.layout,
      togglesidebar: (state) => state.menu.togglesidebar,
      activeoverlay: (state) => state.menu.activeoverlay,
    }),
    layoutobject: {
      get: function () {
        return JSON.parse(
          JSON.stringify(
            layoutClasses.find(
              (item) =>
                Object.keys(item).pop() === this.layout.settings.layout
            )
          )
        )[this.layout.settings.layout];
      },
      set: function () {
        this.layoutobj = layoutClasses.find(
          (item) => Object.keys(item).pop() === this.layout.settings.layout
        );
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
          this.layout.settings.layout
        ];
        return this.layoutobj;
      },
    },
  },
  watch: {
    $route() {
      this.menuItems.filter((items) => {
        if (items.path === this.$route.path)
          this.$store.dispatch('menu/setActiveRoute', items);
        if (!items.children) return false;
        items.children.filter((subItems) => {
          if (subItems.path === this.$route.path)
            this.$store.dispatch('menu/setActiveRoute', subItems);
          if (!subItems.children) return false;
          subItems.children.filter((subSubItems) => {
            if (subSubItems.path === this.$route.path)
              this.$store.dispatch('menu/setActiveRoute', subSubItems);
          });
        });
      });
      this.layoutobj = layoutClasses.find(
        (item) => Object.keys(item).pop() === this.layout.settings.layout
      );
      if (
        (window.innerWidth < 991 &&
          this.layout.settings.layout === 'LosAngeles') ||
        (window.innerWidth < 991 &&
          this.layout.settings.layout === 'Singapore') ||
        (window.innerWidth < 991 &&
          this.layout.settings.layout === 'Barcelona')
      ) {
        const newlayout = JSON.parse(
          JSON.stringify(this.layoutobj).replace(
            'horizontal-wrapper',
            'compact-wrapper'
          )
        );
        this.layoutobj = JSON.parse(JSON.stringify(newlayout))[
          this.layout.settings.layout
        ];
      } else {
        this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
          this.layout.settings.layout
        ];
      }
    },
    sidebar_toggle_var: function () {
      this.resized =
        this.width <= 991
          ? !this.sidebar_toggle_var
          : this.sidebar_toggle_var;
    },
  },
  created() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    this.resized = this.sidebar_toggle_var;
    this.$store.dispatch('layout/set');
    // this.$router.replace({ 'query': null }).catch(err => err);
    this.layout.settings.layout = 'Singapore';
    this.layoutobj = layoutClasses.find(
      (item) => Object.keys(item).pop() === this.layout.settings.layout
    );
    this.layoutobj = JSON.parse(JSON.stringify(this.layoutobj))[
      this.layout.settings.layout
    ];
  },
  async mounted() {
    const self = this;
    let userinfo = localStorage.getItem('userinfo');
    userinfo = JSON.parse(userinfo);
    if (userinfo.role_ccp != undefined) {
      await self.connectSharedWorker();
    }
  },
  methods: {
    async connectSharedWorker() {
      let self = this;
      if (window.Worker) {
        let userinfo = localStorage.getItem('userinfo');
        userinfo = JSON.parse(userinfo);
        //let url = process.env.NODE_ENV === 'production' ? 'wss://itonecsp-ws.cloudcentric.app/itone/socket/ws?' : 'ws://localhost:4011/ws?';
        let url = process.env.NODE_ENV === 'production' ? 'wss://itonecsp-ws.cloudcentric.app/itone/socket/ws?' : 'wss://itonecsp-dev.cloudcentric.app/ws-api/ws?';
        // let url = process.env.NODE_ENV === 'production' ? 'wss://itonecsp-ws.cloudcentric.app/itone/socket/ws?' : 'wss://itonecsp-dev.cloudsoft.co.th/ws-api/ws?';
        let obj = {
          key: userinfo.access_token,
          id: userinfo.user_id,
        };
        for (var key in obj) {
          if (url != '') {
            url += '&';
          }
          url += key + '=' + encodeURIComponent(obj[key]);
        }
        this.WorkerIO = new SharedWorker('./../worker.js?url=' + url, 'NDN-Worker');
        this.WorkerIO.port.start();
        this.$root.$data.WorkerIO = this.WorkerIO;
        this.WorkerIO.port.addEventListener(
          'message',
          function (eventM) {
            var data = eventM.data;
            var msg = data[0];
            if (msg == 'server') {
              switch (data[1]) {
                case 'ping':
                  self.WorkerIO.port.postMessage('pong');
                  break;
                case 'disconnected':
                  self.WorkerIO.port.postMessage('pong');
                  break;
              }
            } else {
              let dataParse = JSON.parse(data[1]);
              if (msg == 'socketEvent') {
                switch (dataParse['name']) {
                  case 'updateStatus':
                    self.$root.$emit('updateStatus', dataParse['data']);
                    break;
                  case 'realtimeQueue':
                    self.$root.$emit('realtimeQueue', dataParse['data']);
                    self.$root.$emit('realtimeMailQueue', dataParse['data']);
                    break;
                  case 'realtimeDashboardQueue':
                    self.$root.$emit('realtimeMailQueue', "");
                    break;
                  case 'notification to agent':
                    self.$root.$emit('notificationToAgent', dataParse['data']);
                    self.$root.$emit('setAgentDesktopTab', 1);
                    break;
                  case 'closeJob':
                    self.$root.$emit('notificationToCloseJob', dataParse['data']);
                    break;
                }
              } else if (msg == 'sharedWorkerEvent') {
                switch (dataParse['name']) {
                  case 'updateTime':
                    self.$root.$emit('realtimeStatusTime', dataParse['time']);
                    break;
                  case 'updateLongTime':
                    self.$root.$emit('realtimeStatusLongTime', dataParse['time']);
                    break;
                  case 'forceQuit':
                    window.location.href = '/login';
                    break
                }
              }
            }
          },
          false
        );
        this.WorkerIO.port.addEventListener(
          'error',
          function (e) {
            throw new Error('WorkerIO Error: could not open SharedWorker', e);
          },
          false
        );
      }
    },
    sidebar_toggle(value) {
      this.sidebar_toggle_var = !value;
    },
    mobiletoggle_toggle(value) {
      this.mobileheader_toggle_var = value;
    },
    handleResize() {
      this.$store.dispatch('menu/resizetoggle');
    },
    removeoverlay() {
      this.$store.state.menu.activeoverlay = false;
      if (window.innerWidth < 991) {
        this.$store.state.menu.togglesidebar = false;
      }
      this.menuItems.filter((menuItem) => {
        menuItem.active = false;
      });
    },
    hidesecondmenu() {
      if (this.layoutobject.split(' ').includes('compact-sidebar')) {
        this.menuItems.filter((menuItem) => {
          menuItem.active = false;
        });
      }
      if (window.innerWidth < 991) {
        this.$store.state.menu.togglesidebar = false;
      }
    },
  },
};
</script>

<style>
.content-move {
  transition: all 0.5s;
}

.content-enter-active {
  transition-duration: 0.3s;
  transition-timing-function: cubic-bezier(0.6, 0.15, 0.35, 0.8);
}

.content-enter,
.content-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}
</style>
